export const CEFR_LEVELS = ["A1", "A2", "B1", "B2", "C1", "C2"] as const;
export type CefrLevel = (typeof CEFR_LEVELS)[number];

export const DECLARED_LEVELS = ["beginner", "basic", "intermediate", "advanced"] as const;
export type DeclaredLevel = (typeof DECLARED_LEVELS)[number];

export const DECLARED_LEVEL_LABELS: Record<DeclaredLevel, string> = {
  beginner: "Iniciante",
  basic: "Básico",
  intermediate: "Intermediário",
  advanced: "Avançado",
};

/** O nível autodeclarado da matrícula vira o CEFR inicial. */
export const DECLARED_TO_CEFR: Record<DeclaredLevel, CefrLevel> = {
  beginner: "A1",
  basic: "A2",
  intermediate: "B1",
  advanced: "B2",
};

export function isCefr(value: string): value is CefrLevel {
  return (CEFR_LEVELS as readonly string[]).includes(value);
}
